/* eslint-disable */
import { Injectable } from '@angular/core';
import { MSLatLng, MSLatLon } from '../models/map.model';
import { GisService } from './gis.service';
import { LoggerService } from './logger.service';
import { StorageService } from './storage.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class PointsHelperService {
  constructor(
    private gis: GisService,
    private storage: StorageService,
    private logger: LoggerService
  ) {
    this.logger.log('Points helper constructor', MSRemoteLoggerCategory.POINTS_HELPER_SERVICE);
  }

  getIntPointsFromFloat(points) {
    return points.map((point) => ({ lat: this.gis.getIntLatOrLon(point.lat), lon: this.gis.getIntLatOrLon(point.lng) }));
  }

  getFloatPointsFromInt(points) {
    return points.map((point) => ({ lat: this.gis.getFloatLatOrLon(point.lat), lng: this.gis.getFloatLatOrLon(point.lon) }));
  }

  getLatLonFromLatLng(point: MSLatLng): MSLatLon {
    const lat = this.gis.getIntLatOrLon(point.lat);
    const lng = this.gis.getIntLatOrLon(point.lng);
    const intPoint: MSLatLon = {
      lat,
      lon: lng
    };

    return intPoint;
  }

  getLatLngFromLatLon(point: MSLatLon): MSLatLng {
    const lat = this.gis.getFloatLatOrLon(point.lat);
    const lon = this.gis.getFloatLatOrLon(point.lon);
    const floatPoint: MSLatLng = {
      lat,
      lng: lon
    };

    return floatPoint;
  }

  getLatLonListFromLatLngList(points: MSLatLng[]): MSLatLon[] {
    return points.map(this.getLatLonFromLatLng.bind(this));
  }

  getLatLngListFromLatLonList(points: MSLatLon[]): MSLatLng[] {
    return points.map(this.getLatLngFromLatLon.bind(this));
  }

  getPointsFromSurvey(survey) {
    const points = [];

    // if we have start, use it
    if (survey.startLat && survey.startLon) {
      points.push({ lat: survey.startLat, lon: survey.startLon });
    }

    // otherwise, use farthest point for loop and stop point for all others
    if (survey.addedTripType === 'LOOP' && survey.addedLat && survey.addedLon) {
      points.push({ lat: survey.addedLat, lon: survey.addedLon });
    } else if (survey.stopLat && survey.stopLon) {
      points.push({ lat: survey.stopLat, lon: survey.stopLon });
    }

    return this.getLatLngListFromLatLonList(points);
  }

  getPointsFromLocDb(current, includeTime, includeSplits, includeReverses) {
    const self = this;
    const simplifyPoints = function (pointsData) {
      let points;

      //get origin point
      //if (usePreviousTripForOrigin(earlier, isLd)) {
      //points[0] = {lat: gis.getFloatLatOrLon(earlier.stopLat), lon: gis.getFloatLatOrLon(earlier.stopLon)};
      //}

      points = pointsData.locations.map((point) =>
        //return Object.assign(new google.maps.LatLng(point.lat, point.lon), {time: point.time});
        Object.assign({ lat: point.lat, lng: point.lon }, { time: point.time })
      );

      pointsData.locations = points;
      return pointsData;
    };
    const fetchPoints = function () {
      return self.storage.getPointsForTimes(current.startTime, current.stopTime, includeTime, includeSplits, includeReverses);
    };
    const createPoints = function () {
      return fetchPoints().then(simplifyPoints); //.then(cachePoints);
    };

    return createPoints();
  }

  getPoints(earlier, current, isLd, includeTime, includeSplits = false, includeReverses = false) {
    let point;
    let points = {
      locations: [],
      trips: []
    };

    return this.getPointsFromLocDb(current, includeTime, includeSplits, includeReverses).then((dbPoints) => {
      // we're return points. if we have collected points, start with them
      if (dbPoints.locations) {
        points = dbPoints;
      }

      // if the user adjusted the start time we won't have a matching loc in the db
      // use the survey's start loc in this case
      if (current.userAddedStartTime) {
        point = { lat: this.gis.getFloatLatOrLon(current.startLat), lng: this.gis.getFloatLatOrLon(current.startLon) };
        points.locations[0] = Object.assign(point, { time: current.startTime });
      }

      // if it's short-distance, and the previous trip is user added one-way, replace start point
      if (!isLd && earlier && earlier.addedTripType === 'ONE_WAY' && earlier.addedSuccess) {
        point = { lat: this.gis.getFloatLatOrLon(earlier.stopLat), lng: this.gis.getFloatLatOrLon(earlier.stopLon) };
        points.locations[0] = Object.assign(point, { time: current.startTime });
      }

      if (current.addedTripType === 'LOOP') {
        points.locations.push({ lat: this.gis.getFloatLatOrLon(current.addedLat), lng: this.gis.getFloatLatOrLon(current.addedLon) });
      } else if (current.userAddedStopTime) {
        point = { lat: this.gis.getFloatLatOrLon(current.stopLat), lng: this.gis.getFloatLatOrLon(current.stopLon) };
        points.locations.push(Object.assign(point, { time: current.stopTime }));
      }

      //TODOJS
      //what if loop?
      //what if previous is one-way added?

      return points;
    });
  }

  getLostPointIndices(pointsData) {
    // pointsData format from a getPointsForTimes call, like from getPointsFromLocDb below
    // var indices = [],
    //     locs = pointsData.locations,
    //     locI = 0,
    //     trips = pointsData.trips,
    //     // TODO configure?
    //     //lostPickupMeters = 400, // ~.25 miles
    //     lostPickupMeters = CONSTANTS.PICKUP_THRESHOLD_MILES * gis.METERS_PER_MILE,	//if we set this threshold below our standard threshold, you'll have folks trying to split within the 1 second between 1st and 2nd points
    //     lostAppDiedSeconds = 15 * 60,
    //     lastStopSeconds = -1;
    // trips.forEach(function (trip) {
    //     if ((trip.appDied && trip.startTime - lastStopSeconds > lostAppDiedSeconds) || // 1st w/ appDied always true
    //         (trip.pickupMeters > lostPickupMeters)) {
    //         for (; locI < locs.length; locI++) {
    //             if (locs[locI].time == trip.startTime) {		//potential issue if user updated the trip start time
    //                 indices.push(locI);
    //                 break;
    //             }
    //         }
    //     }
    //     lastStopSeconds = trip.stopTime;
    // });
    // return indices;
  }

  getPointsForSplit(pointsData, surveyData) {
    /***
        any start point is one second before the second point

        if 2 or more trips are merged, the start point for each subsequent trip is problematic b/c it's one second before the next point.
        do we remove the start point of the latter merged trip, do we amend it's time, or do we ask the user to update the time
        if we use option 3, we can force users to amend the point time of the latter leg when we first get it, but that requires
        amending the time prior to merging. perhaps we can ask later on.

        if a trip is split a latter gap, earlier trip would display fine
        later trip will have a start during the gap, then retreat to earlier stop point, then move forward
        need to
        ***/

    const gapSegs = [];
    const points = pointsData.locations;
    // lostPointIndices = getLostPointIndices(pointsData);
    const lostPointIndices = [];

    //always allow split during cold start?
    //without this, had issue when splitting and latter trip had no trip points but also not roster added
    if (surveyData.userAddedStartTime && lostPointIndices.indexOf(0) === -1) {
      lostPointIndices.unshift(0);
    }

    lostPointIndices.forEach((idx) => {
      const newIdx = idx + gapSegs.length;
      const ptA = points[newIdx];
      const ptB = points[newIdx + 1];
      const midPoint = { lat: (ptA.lat + ptB.lat) / 2, lng: (ptA.lng + ptB.lng) / 2 };

      gapSegs.push([ptA, ptB]);
      points.splice(newIdx + 1, 0, Object.assign(midPoint, { isGap: true }));
      if (newIdx !== 0) {
        points[newIdx].time = points[newIdx - 1].time;
      }
    });

    return { locations: points, gapSegs };
  }
}
